module.exports = __webpack_public_path__ + "img/Fs_Ui_Info_Melon_01.82bb49a8.png";